export const HOST_API = process.env.REACT_APP_HOST_API_URL || "";
export const HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY || "";
